import React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../store";
import DatePicker, { DatePickerType } from "../../../components/DatePicker";
import { Container, Box } from "../styles";
import Search, { SearchProps } from "../Search";
import { useCookies } from "react-cookie";
import moment from "moment";

const Handler = () => {
  const {
    HistoryStore: {
      nowDate,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      searchText,
      setSearchText,
      searchHandler,
    },
  } = useStore();

  const startDateProps: DatePickerType = {
    label: "Start Date",
    date: startDate,
    setDate: setStartDate,
    maxDate: endDate,
  };

  const endDateProps: DatePickerType = {
    label: "End Date",
    date: endDate,
    setDate: setEndDate,
    maxDate: nowDate,
    minDate: startDate,
  };

  const searchProps: SearchProps = {
    value: searchText,
    textHandler: (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    removeHandler: () => {
      setSearchText("");
    },
    action: () => {
      searchHandler();
    },
    keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") searchHandler();
    },
  };

  return (
    <Container>
      <Box>
        <DatePicker {...startDateProps} />
        <DatePicker {...endDateProps} />
      </Box>
      <Search {...searchProps} />
    </Container>
  );
};

export default observer(Handler);
